import React, { } from 'react';
import SiteLayout from '../SiteLayout';
import { useTranslation } from 'react-i18next';

const Partners = () => {
  const { t } = useTranslation();
  const pageCode = 'partners';
  return (
    <SiteLayout
      helmetData={{
        name: t(pageCode + 'SEO'),
        description: t(pageCode + 'SEODesc'),
      }}
    >
      <div></div>
    </SiteLayout>
  );
};

export default Partners;
